import { useState, useEffect, useCallback } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {config} from '../../config'
import Sidebar from '../../components/sidebar/Sidebar'
import Header from '../../components/headerbar/Header'
import axios from 'axios'
import { Pagination, Typography } from '@mui/material'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import Divider from '@mui/material/Divider';
import { formatISODateToCustomFormat } from '../../utils'

const Products = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [products, setProducts] = useState([])

  const initialParams = {
    search: "",
    page: 1,
    limit: 10,
  };
  const [params, setParams] = useState(initialParams)
  const [totalResult, setTotalResult] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  const [search, setSearch] = useState("");


  const navigate = useNavigate()

  // Get Products
  const getProducts = useCallback(() => {
    let url = config.apiurl + '/product/getproductlist'

    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        !res?.data?.data?.length && toast("No Data found...!", {
              type: "info",
              autoClose: 900,
            });
        setProducts(res?.data?.data)
        setTotalResult(res?.data?.pagination?.totalResults)
        setCurrentPage(res?.data?.pagination?.page)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"})

    axios.get(url, { params }).then(onSuccess, onFailure)
  }, [params])
  useEffect(() => {
    getProducts()
  }, [getProducts, params])

  const deleteProduct = async (id) => {
    let deletecat = await fetch(config.apiurl + '/product/' + id, {
      method: 'Delete',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    deletecat = await deletecat.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    if (deletecat) {
      (totalResult % params.limit) === 1 ? setParams(prevParams => ({...prevParams, page: prevParams.page - 1})) : getProducts()
    }
  }

  // Handle pagination
  const handlePagination = (event, value) => {
    if (typeof value === 'number') {
      setCurrentPage(value)
      setParams((prevState) => ({ ...prevState, page: value }))
      // setPageQuery({ ...pageQuery, page: value })
    }
  }

  const handleReset = () => {
    setSearch("");
    setParams({
      search: "",
      page: 1,
      limit: 10,
    })
  }

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1)
    setParams({
      search: search?.trim(),
      page: 1,
      limit: 10,
    })
  }

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Product Upload</h6>
                    </div>

                    <div className="col-6 text-end">
                      <Link
                        className="btn bg-gradient-dark mb-0"
                        to="/product/add"
                      >
                        <i className="fas fa-plus" aria-hidden="true"></i>
                        &nbsp;&nbsp;Add New Product Upload
                      </Link>
                    </div>
                  </div>
                </div>

                <Paper
                  component="form"
                  onSubmit={handleSearch}
                  sx={{
                    p: "2px 4px",
                    m: "10px 10px 10px auto",
                    display: "flex",
                    alignItems: "end",
                    width: 250,
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1, height: "2.4375em" }}
                    placeholder="Search"
                    inputProps={{ "aria-label": "search", "spellcheck": "false" }}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <IconButton
                    type="submit"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    onClick={handleReset}
                    sx={{ p: "10px" }}
                    aria-label="reset"
                  >
                    <RestartAltIcon />
                  </IconButton>
                </Paper>
                <Divider variant="middle" />

                <div className="card-body px-0 pt-0 pb-2">
                  <div className="table-responsive p-3">
                    <table className="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-secondary opacity-7 ps-2">
                            S.No
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Category
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Details
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Created At
                          </th>
                          <th className="text-secondary opacity-7">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(products) &&
                          products.map((item, index) => (
                            <tr key={item._id}>
                              <td>
                                {currentPage > 1
                                  ? `${
                                      index + 1 === 10
                                        ? currentPage
                                        : currentPage - 1
                                    }${index + 1 === 10 ? 0 : index + 1}`
                                  : index + 1}
                              </td>
                              <td>
                                <p
                                  className="text-xs font-weight-bold mb-0"
                                  style={{ wordWrap: ' break-word' }}
                                >
                                  {item.maincategory}
                                </p>
                              </td>
                              <td>
                                <div className="d-flex px-2 py-1">
                                  <div>
                                    <img
                                      src={
                                        config.fileurl +
                                          item.image?.[0]?.filename ||
                                        '/img/error.png'
                                      }
                                      className="avatar avatar-sm me-3"
                                      alt={item.title}
                                    />
                                  </div>
                                  <div className="d-flex flex-column justify-content-center">
                                    <p className="text-xs mb-2">
                                      Name:{' '}
                                      <span
                                        className="text-secondary"
                                        style={{ wordWrap: ' break-word' }}
                                      >
                                        {item?.name}
                                      </span>{' '}
                                    </p>
                                    <p className="text-xs mb-2">
                                      Product:{' '}
                                      <span className="text-secondary">
                                        {item?.subcategory}
                                      </span>{' '}
                                    </p>
                                    <p className="text-xs mb-2">
                                      Sub Product:{' '}
                                      <span className="text-secondary">
                                        {item?.product_stylename}
                                      </span>{' '}
                                    </p>
                                    <p className="text-xs mb-2">
                                      SKUID:{' '}
                                      <span className="text-secondary">
                                        {item?.skuid}
                                      </span>{' '}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex px-2 py-1">
                                  <div className="d-flex flex-column justify-content-center">
                                    <h6 className="mb-0 text-sm">
                                      {formatISODateToCustomFormat?.(item?.createdAt) ?? "-"}
                                    </h6>
                                  </div>
                                </div>
                              </td>   
                              <td>
                                <Link
                                  to={'/product/' + item.productid}
                                  className="btn btn-link text-dark px-4 mb-0"
                                >
                                  <i
                                    className="fas fa-pencil-alt text-dark me-2"
                                    aria-hidden="true"
                                  ></i>
                                  Edit
                                </Link>
                                <a
                                  className="btn btn-link text-danger text-gradient px-3 mb-0"
                                  onClick={() => deleteProduct(item.productid)}
                                >
                                  <i
                                    className="far fa-trash-alt me-2"
                                    aria-hidden="true"
                                  ></i>
                                  Delete
                                </a>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-12 paginationWrapper">
                  {/* Pagination */}
                  {totalResult < 11 ? (
                    <></>
                  ) : (
                    <section className={'paginationWrapper'}>
                      <section>
                        <Typography variant="body1">
                          Page {currentPage} of{' '}
                          {Math.ceil(totalResult / params.limit)}
                        </Typography>
                      </section>
                      <Pagination
                        count={Math.ceil(totalResult / params.limit)}
                        page={currentPage}
                        onChange={handlePagination}
                        color="primary"
                        shape="rounded"
                      />
                    </section>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </main>
    </>
  )
}

export default Products
